import { render, staticRenderFns } from "./MemberWriteProfileSettingLayout.vue?vue&type=template&id=4f2ddadf&scoped=true"
import script from "./MemberWriteProfileSettingLayout.vue?vue&type=script&lang=js"
export * from "./MemberWriteProfileSettingLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2ddadf",
  null
  
)

export default component.exports